import React from 'react';
import { Grid, Container } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import 'flag-icon-css/css/flag-icon.min.css';
import Language from './Language';
import Nav from './Nav';
import AuthenticationButton from './AuthenticationButton';
import Header from './Header';

const NavBar = ({ darkMode, setDarkMode }) => {
	const { t } = useTranslation();

	React.useEffect(() => {
		document.title = t('title');
	});
	return (
		<div>
			<Grid container direction='column'>
				{/* <Grid item>
					<Header />
				</Grid>
				<Grid item>
					<Container>
						<Grid container justify='flex-end' alignItems='center' spacing={2}>
							<Grid item>
								<Language darkMode={darkMode} setDarkMode={setDarkMode} />
							</Grid>
						</Grid>
					</Container>
				</Grid> */}
				<Grid item>
					<Nav darkMode={darkMode} setDarkMode={setDarkMode} />
				</Grid>
			</Grid>
		</div>
	);
};

export default NavBar;
